import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
    title: {
        marginTop: '32px',
        textAlign: 'left',

        '@media (min-width: 768px)' : {
            marginTop: '80px',
            fontSize: '24px',
            lineHeight: '28px',
            textAlign: 'center'
        }
    },
    description: {
        fontSize: '18px',
        lineHeight: '26px',
        textAlign: 'left',
        margin: '16px 0 32px',

        '@media (min-width: 768px)' : {
            fontSize: '20px',
            lineHeight: '28px',
            textAlign: 'center',
            margin: '16px 0 40px',
        }
    },
    weightFactorsIllustrationWrapper: {
        width: '100%',
        maxWidth: '560px',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '12px',

        '@media (min-width: 768px)' : {
            marginBottom: '16px'
        },

        '@media (max-width: 320px)' : {
            '& img': {
                width: '100%'
            },
        }
    }
});
